export default {
  factory: {
    city: { en: "Ivano-Frankivsk", uk: "Івано-Франківськ" },
    street: { en: "I.Makuha str., 6", uk: "вул. І.Макуха, 6" },
    postalCode: "76014",
    phones: ["+380503770801", "+380673270801", "+380342522127"],
    position: [48.9064118, 24.7253379],
    email: "kuvert.ua@kuvert.if.ua",
  },
  offices: [
    {
      city: { en: "Kyiv", uk: "Київ" },
      street: {
        en: "Delivery of goods by prior arrangement.",
        uk: "Доставка товару за попередньою домовленістю.",
      },
      // postalCode: "03134",
      phones: ["+380670090801", "+380504334581"],
      position: [50.450001, 30.523333],
      email: "kuvert.kyiv@gmail.com",
    },
    {
      city: { en: "Dnipro", uk: "Дніпро" },
      street: {
        en: "Delivery of goods by prior arrangement.",
        uk: "Доставка товару за попередньою домовленістю.",
      },
      // postalCode: "49000",
      phones: ["+380504332838"],
      position: [48.4647, 35.0461],
      email: "kuvert.dn@gmail.com",
    },
    {
      city: { en: "Lviv", uk: "Львів" },
      street: {
        en: "Delivery of goods by prior arrangement.",
        uk: "Доставка товару за попередньою домовленістю.",
      },
      // postalCode: "79035",
      phones: ["+380503170387"],
      position: [49.84167, 24.03194],
      email: "konwert@ukr.net",
    },
  ],
}
